import(/* webpackMode: "eager" */ "/builds/91/yellosun/ysn-frontend/node_modules/@magnolia/react-editor/dist/client/components/EditableComment/EditableComment.js");
;
import(/* webpackMode: "eager", webpackExports: ["nameSpaces"] */ "/builds/91/yellosun/ysn-frontend/src/app/i18n/client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/accordion/AccordionElement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/alertBox/AlertBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/booking/BookingDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/bookingList/BookingList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/button/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/checkout/Checkout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/ClientOverlay/ClientOverlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/consentButton/ConsentButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/Destinations/Destinations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/featureList/FeatureList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/fixedColumnLayout/FixedColumnLayout.tsx");
;
import(/* webpackMode: "eager" */ "/builds/91/yellosun/ysn-frontend/src/components/Headline.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/hotel/HotelInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/ibe/ibeSearch/IbeSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/ibe/IbeWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/image/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/leftNavi/LeftNavi.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/linkList/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/linkList/LinkList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/newsletter/Newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/offer/Offer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/offer/OfferFixedColumnLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/password/PasswordChange.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/poster/Poster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/quotes/Quotes.tsx");
;
import(/* webpackMode: "eager" */ "/builds/91/yellosun/ysn-frontend/src/components/RichText/RichText.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/tabs/Tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/components/teaser/Teaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/Layouts/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/Layouts/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/templates/MagnoliaPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/91/yellosun/ysn-frontend/src/templates/pages/StaticPage.tsx");
